(() => {
  const root = document.querySelector(".ha-quiz");
  if (!root) return;

  const form = root.querySelector("[data-quiz]");
  const screens = [...form.querySelectorAll("[data-screen]")];
  const progressFill = root.querySelector("[data-progress]");
  const stepCounter = root.querySelector("[data-step-counter]");
  const backBtn = root.querySelector("[data-back]");
  const ctaUrl = root.dataset.ctaUrl || "/products/flow-bebida-funcional-em-po";
  // Screens past the loader = the payoff. Hide quiz chrome + use brand CTA.
  const RESULT_PHASE = new Set(["summary", "map", "bridge", "result"]);
  const applyChrome = (name) =>
    root.classList.toggle("ha-quiz--result-phase", RESULT_PHASE.has(name));
  const summaryLabels = {
    age: "Faixa etária",
    feel: "Fim do dia",
    symptoms: "Sinais recentes",
    diet: "Alimentação",
    gut: "Intestino",
    coffee: "Café e energia",
    focus: "Foco",
    tried: "O que já tentou",
    consistency: "Consistência",
    goals: "Objetivos",
  };

  const total = screens.length;
  let index = 0;
  const history = [];
  let lastFocus = ""; // primary focus area, carried from summary into the offer

  // Funnel instrumentation: GA4/Elevar (dataLayer) + Triple Whale (TriplePixel) are
  // store-local and always fire. First-party beacon only fires if a Livera endpoint
  // is configured on the section (data-beacon-url) — never leaks to another brand's warehouse.
  const QUIZ = "eon-flow";
  const BEACON_URL = root.dataset.beaconUrl || "";
  const sid = (function () {
    try {
      let v = sessionStorage.getItem("eon_quiz_sid");
      if (!v) {
        v = "q-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
        sessionStorage.setItem("eon_quiz_sid", v);
      }
      return v;
    } catch (e) { return "q-" + Math.random().toString(36).slice(2, 14); }
  })();
  let beaconBuffer = [];

  function flushBeacon() {
    if (!BEACON_URL || !beaconBuffer.length) { beaconBuffer = []; return; }
    const events = beaconBuffer;
    beaconBuffer = [];
    try {
      const blob = new Blob(
        [JSON.stringify({ quiz: QUIZ, session_id: sid, events: events })],
        { type: "text/plain" } // simple request: no CORS preflight
      );
      if (navigator.sendBeacon) navigator.sendBeacon(BEACON_URL, blob);
    } catch (e) { /* never break the quiz */ }
  }

  function track(event, data) {
    try {
      const payload = Object.assign({ quiz: QUIZ }, data || {});
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: event }, payload));
      }
      if (typeof window.TriplePixel === "function") {
        window.TriplePixel("custom", event, payload);
      }
      beaconBuffer.push(Object.assign({ event: event, ts: Date.now() }, data || {}));
      if (
        beaconBuffer.length >= 12 ||
        event === "quiz_complete" ||
        event === "quiz_cta_click"
      ) {
        flushBeacon();
      }
    } catch (e) { /* analytics must never break the quiz */ }
  }

  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") flushBeacon();
  });
  window.addEventListener("pagehide", flushBeacon);

  function setStep(next, push = true) {
    if (next < 0 || next >= screens.length) return;
    if (push && next !== index) history.push(index);
    screens[index].classList.remove("is-active");
    index = next;
    const screen = screens[index];
    screen.classList.add("is-active");

    const pct = Math.round(((index + 1) / total) * 100);
    progressFill.style.width = pct + "%";
    stepCounter.textContent = `${index + 1} / ${total}`;
    backBtn.hidden = history.length === 0;

    window.scrollTo({ top: 0, behavior: "smooth" });

    const screenName = screen.dataset.screen;
    applyChrome(screenName);
    location.hash = screenName;
    track("quiz_step", { step: screenName, index: index + 1, total: total });

    if (screenName === "loader") runLoader(screen);
    if (screenName === "trust") initCarousel(screen);
    if (screenName === "summary") renderSummary(screen);
    if (screenName === "map") renderMap(screen);
    if (screenName === "bridge") renderBridge(screen);
    if (screenName === "result") {
      const focusEl = screen.querySelector("[data-offer-focus]");
      if (focusEl && lastFocus) {
        focusEl.textContent = "Seu foco nº 1: " + lastFocus;
        focusEl.hidden = false;
      }
      const cta = screen.querySelector("[data-cta]");
      if (cta) {
        cta.href = ctaUrl;
        if (!cta.dataset.trackBound) {
          cta.dataset.trackBound = "1";
          cta.addEventListener("click", function () {
            track("quiz_cta_click", { step: "result" });
          });
        }
      }
    }

    setTimeout(() => {
      const firstInput = screen.querySelector("input");
      if (firstInput) firstInput.focus({ preventScroll: true });
    }, 50);
  }

  function isAnswered(screen) {
    if (!screen.hasAttribute("data-required")) return true;
    const inputs = screen.querySelectorAll("input[type=radio], input[type=checkbox]");
    return [...inputs].some((i) => i.checked);
  }

  function runLoader(screen) {
    const items = [...screen.querySelectorAll("[data-step]")];
    const ms = parseInt(screen.dataset.autoAdvance || "4500", 10);
    const each = Math.max(400, Math.floor(ms / items.length));
    items.forEach((it) => it.classList.remove("is-active", "is-done"));
    items.forEach((item, i) => {
      setTimeout(() => {
        items.forEach((x) => x.classList.remove("is-active"));
        item.classList.add("is-active");
        if (i > 0) items[i - 1].classList.add("is-done");
      }, each * i);
    });
    setTimeout(() => {
      items.forEach((x) => x.classList.remove("is-active"));
      items.forEach((x) => x.classList.add("is-done"));
      setStep(index + 1);
    }, each * items.length);
  }

  function getAnswers() {
    const data = new FormData(form);
    const out = {};
    for (const [k, v] of data.entries()) {
      if (out[k] === undefined) out[k] = v;
      else if (Array.isArray(out[k])) out[k].push(v);
      else out[k] = [out[k], v];
    }
    return out;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  }

  function listPhrase(a) {
    if (!a.length) return "os sinais que você descreveu";
    if (a.length === 1) return a[0];
    if (a.length === 2) return a[0] + " e " + a[1];
    return a.slice(0, -1).join(", ") + " e " + a[a.length - 1];
  }

  // Map each pain the user actually reports to what the formula does about it.
  // Plain, honest, and only triggered by answers they marked (no invented claims).
  function buildInsights(answers) {
    const arr = (k) => (answers[k] ? (Array.isArray(answers[k]) ? answers[k] : [answers[k]]) : []);
    const symptoms = arr("symptoms");
    const goals = arr("goals");
    const feel = answers.feel || "";
    const gut = answers.gut || "";
    const coffee = answers.coffee || "";
    const focus = answers.focus || "";
    const diet = answers.diet || "";
    const symHas = (s) => symptoms.some((x) => x.toLowerCase().includes(s));
    const goalHas = (s) => goals.some((x) => x.toLowerCase().includes(s));

    const catalog = [
      {
        on: symHas("estufamento") || symHas("inchaço") || feel.indexOf("nchad") > -1 || goalHas("leve"),
        pain: symHas("estufamento") ? "Você sente estufamento depois das refeições" : "Você termina o dia com inchaço",
        action: "As 4 fibras prebióticas favorecem regularidade e conforto intestinal, reduzindo o desconforto abdominal.",
        tone: "#243a38", icon: "M12 2C8 6 6 9 6 13a6 6 0 0012 0c0-4-2-7-6-11z",
      },
      {
        on: gut.indexOf("Irregular") > -1 || gut.indexOf("preso") > -1 || symHas("irregular") || goalHas("regularidade"),
        pain: "Seu intestino não tem um ritmo previsível",
        action: "Prebióticos alimentam as bactérias boas que já vivem no seu intestino — é isso que regula a digestão.",
        tone: "#3d5a4e", icon: "M21 13a9 9 0 11-7.5-8.86A7 7 0 0021 13z",
      },
      {
        on: diet.indexOf("Poucas") > -1 || diet.indexOf("Quase nunca") > -1 || symHas("digestão"),
        pain: "Faltam fibras e vegetais no seu dia a dia",
        action: "O brasileiro consome só 60% da recomendação de fibras (IBGE). Flow completa o que a alimentação moderna não entrega.",
        tone: "#5c6e3f", icon: "M12 2l8 4v6c0 5-3.4 8.4-8 10-4.6-1.6-8-5-8-10V6l8-4z",
      },
      {
        on: coffee.indexOf("3") > -1 || coffee.indexOf("cafe em cafe") > -1 || symHas("energia") || symHas("queda") || goalHas("energia"),
        pain: "Sua energia oscila e depende de café",
        action: "Complexo B e nutrientes essenciais apoiam a produção de energia ao longo do dia — mais estável, sem picos.",
        tone: "#8a8a3d", icon: "M13 2L3 14h7l-1 8 10-12h-7l1-8z",
      },
      {
        on: focus.indexOf("Cai a tarde") > -1 || focus.indexOf("Dificil") > -1 || symHas("foco") || goalHas("foco") || goalHas("clareza"),
        pain: "O foco cai ao longo da tarde",
        action: "Cerca de 90% da serotonina é produzida no intestino. Um eixo intestino-cérebro equilibrado impacta foco e cognição.",
        tone: "#243a38", icon: "M12 2l2.2 6.6L21 11l-6.8 2.4L12 20l-2.2-6.6L3 11l6.8-2.4z",
      },
    ];
    return catalog.filter((c) => c.on);
  }

  function renderMap(screen) {
    const answers = getAnswers();
    let insights = buildInsights(answers);
    if (insights.length < 2) {
      const fallback = [
        { pain: "A alimentação moderna não sustenta o intestino", action: "4 fibras prebióticas, 8 superfoods e 12 vitaminas — em uma dose por dia.", tone: "#243a38", icon: "M12 2C8 6 6 9 6 13a6 6 0 0012 0c0-4-2-7-6-11z" },
        { pain: "Sinais pequenos que se acumulam", action: "Intestino bem nutrido participa do equilíbrio do corpo inteiro: digestão, energia e foco.", tone: "#5c6e3f", icon: "M12 2l8 4v6c0 5-3.4 8.4-8 10-4.6-1.6-8-5-8-10V6l8-4z" },
      ];
      fallback.forEach((f) => { if (insights.length < 2) insights.push(f); });
    }
    insights = insights.slice(0, 4);
    const list = screen.querySelector("[data-map-list]");
    if (!list) return;
    list.innerHTML = insights
      .map(
        (i) =>
          '<li class="ha-map__row" style="--tone:' + (i.tone || "#243a38") + '">' +
          '<span class="ha-map__icon" aria-hidden="true"><svg width="19" height="19" viewBox="0 0 24 24" fill="none"><path d="' + (i.icon || "M12 2C8 6 6 9 6 13a6 6 0 0012 0c0-4-2-7-6-11z") + '" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
          '<div class="ha-map__body">' +
          '<p class="ha-map__pain">' + escapeHtml(i.pain) + "</p>" +
          '<p class="ha-map__action"><span class="ha-map__arrow" aria-hidden="true">→</span>' + escapeHtml(i.action) + "</p>" +
          "</div>" +
          "</li>"
      )
      .join("");
  }

  function renderSummary(screen) {
    const answers = getAnswers();
    const arr = (k) => (answers[k] ? (Array.isArray(answers[k]) ? answers[k] : [answers[k]]) : []);

    // Subscores 0-100 (maior = melhor)
    const symptoms = arr("symptoms");
    const goals = arr("goals");
    const feel = answers.feel || "";
    const diet = answers.diet || "";
    const gutAns = answers.gut || "";
    const coffee = answers.coffee || "";
    const focusAns = answers.focus || "";
    const tried = answers.tried || "";
    const consistency = answers.consistency || "";

    const symHas = (s) => symptoms.some((x) => x.toLowerCase().includes(s));
    const goalHas = (s) => goals.some((x) => x.toLowerCase().includes(s));

    // Digestão & inchaço
    let digestao = 70;
    if (feel.indexOf("nchad") > -1) digestao -= 22;
    if (symHas("estufamento")) digestao -= 15;
    if (symHas("inchaço")) digestao -= 12;
    if (symHas("digestão")) digestao -= 10;

    // Fibras na alimentação
    let fibras = 70;
    if (diet.indexOf("Quase nunca") > -1) fibras -= 28;
    else if (diet.indexOf("Poucas") > -1) fibras -= 20;
    else if (diet.indexOf("Algumas") > -1) fibras -= 8;
    if (gutAns.indexOf("preso") > -1) fibras -= 10;
    if (tried === "Nada ainda") fibras -= 6;

    // Energia
    let energia = 70;
    if (coffee.indexOf("3 ou mais") > -1 || coffee.indexOf("cafe em cafe") > -1) energia -= 24;
    else if (coffee.indexOf("2") > -1) energia -= 12;
    if (symHas("queda") || symHas("energia")) energia -= 14;
    if (feel.indexOf("sgotad") > -1) energia -= 10;

    // Foco & eixo intestino-cérebro
    let foco = 70;
    if (focusAns.indexOf("Cai a tarde") > -1) foco -= 22;
    else if (focusAns.indexOf("Dificil") > -1) foco -= 26;
    if (symHas("foco")) foco -= 10;
    if (consistency.indexOf("esqueço") > -1) foco -= 6;

    const clamp = (n) => Math.max(8, Math.min(95, Math.round(n)));
    digestao = clamp(digestao);
    fibras = clamp(fibras);
    energia = clamp(energia);
    foco = clamp(foco);

    const overall = Math.round((digestao + fibras + energia + foco) / 4);

    const labelFor = (n) =>
      n < 30 ? "Baixo" :
      n < 55 ? "Regular" :
      n < 75 ? "Bom" :
      "Forte";

    const badgeFor = (n) =>
      n < 25 ? "BAIXO" :
      n < 50 ? "BAIXO-MODERADO" :
      n < 70 ? "MODERADO" :
      n < 85 ? "BOM" :
      "ALTO";

    screen.querySelector("[data-result-badge]").textContent = badgeFor(overall);
    const fill = screen.querySelector("[data-gauge-fill]");
    const marker = screen.querySelector("[data-gauge-marker]");
    if (fill) fill.style.width = overall + "%";
    if (marker) marker.style.left = overall + "%";

    // Each system card: short status word + a visual level meter (low = amber)
    const applyCard = (cardKey, meterKey, n) => {
      const val = screen.querySelector("[data-card='" + cardKey + "']");
      if (val) { val.textContent = labelFor(n); val.classList.toggle("ha-result__card-value--low", n < 40); }
      const fillEl = screen.querySelector("[data-meter='" + meterKey + "']");
      if (fillEl) { fillEl.style.width = Math.max(6, n) + "%"; fillEl.classList.toggle("ha-result__meter-fill--low", n < 40); }
    };
    applyCard("digestao", "digestao", digestao);
    applyCard("fibras", "fibras", fibras);
    applyCard("energia", "energia", energia);
    applyCard("foco", "foco", foco);

    // Primary focus area = the weakest subscore (the root cause to address first)
    const focusMap = { digestao: "Digestão & inchaço", fibras: "Fibras na alimentação", energia: "Energia estável", foco: "Foco & eixo intestino-cérebro" };
    const subs = { digestao: digestao, fibras: fibras, energia: energia, foco: foco };
    const weakest = Object.keys(subs).reduce((a, b) => (subs[a] <= subs[b] ? a : b));
    const focusEl = screen.querySelector("[data-primary-focus]");

    // Link the plan AND the primary focus to the stated GOALS. Falls back to the
    // weakest scored system if no goals were marked.
    const goalMap = {
      "Terminar o dia leve": { sys: "digestao", phrase: "terminar o dia leve" },
      "Regularidade intestinal": { sys: "fibras", phrase: "ter regularidade intestinal" },
      "Energia estável": { sys: "energia", phrase: "ter energia estável" },
      "Mais foco e clareza": { sys: "foco", phrase: "ter mais foco e clareza" },
      "Cuidar da alimentação de forma simples": { sys: "fibras", phrase: "cuidar da alimentação de forma simples" },
    };
    const goalList = arr("goals");
    const goalSystems = {};
    const goalPhrases = [];
    goalList.forEach((g) => {
      const m = goalMap[g];
      if (m) { goalSystems[m.sys] = true; if (goalPhrases.indexOf(m.phrase) === -1) goalPhrases.push(m.phrase); }
    });
    const hasGoals = goalPhrases.length > 0;

    // Primary focus = the goal area that needs the most support today
    // (weakest scored system among the goals).
    const scoredGoals = Object.keys(goalSystems).filter((s) => subs[s] !== undefined);
    let focusKey = weakest;
    if (scoredGoals.length) focusKey = scoredGoals.reduce((a, b) => (subs[a] <= subs[b] ? a : b));
    if (focusEl) focusEl.textContent = focusMap[focusKey];
    lastFocus = focusMap[focusKey];

    screen.querySelectorAll("[data-blend-system]").forEach((el) => {
      const match = hasGoals ? !!goalSystems[el.dataset.blendSystem] : el.dataset.blendSystem === weakest;
      el.classList.toggle("ha-plan__blend--focus", match);
      const tag = el.querySelector("[data-blend-tag]");
      if (tag) tag.hidden = !match;
    });
    const leadEl = screen.querySelector(".ha-plan__lead");
    if (leadEl && hasGoals) {
      leadEl.innerHTML = "Você quer <strong>" + escapeHtml(listPhrase(goalPhrases.slice(0, 3))) + "</strong>. O plano mira exatamente isso.";
    }

    // Build a phrase from the symptoms they actually marked, so the copy mirrors them.
    const shortMap = {
      "Estufamento após refeições": "estufamento após as refeições",
      "Inchaço no fim do dia": "inchaço no fim do dia",
      "Intestino irregular": "intestino irregular",
      "Digestão lenta": "digestão lenta",
      "Queda de energia à tarde": "queda de energia à tarde",
      "Dificuldade de foco": "dificuldade de foco",
      "Dependência de café": "dependência de café",
    };
    const reported = symptoms.map((s) => shortMap[s] || s.toLowerCase()).slice(0, 3);
    if (reported.length < 2) {
      if (feel.indexOf("nchad") > -1 && reported.indexOf("inchaço no fim do dia") === -1) reported.push("inchaço no fim do dia");
      if (coffee.indexOf("3 ou mais") > -1 && reported.indexOf("dependência de café") === -1) reported.push("dependência de café");
    }
    const hasReported = reported.length > 0;
    const reportedPhrase = listPhrase(reported);

    // Personalize alert copy — names the signals they reported, score sets the tone.
    const title = screen.querySelector("[data-alert-title]");
    const copy = screen.querySelector("[data-alert-copy]");
    if (overall < 50) {
      title.textContent = "Seu intestino precisa de suporte diário mais consistente.";
      copy.textContent = hasReported
        ? "Rastreamos " + reportedPhrase + " até um intestino que não recebe as fibras de que precisa."
        : "Esses sinais apontam para um intestino que não recebe as fibras de que precisa.";
    } else if (overall < 75) {
      title.textContent = "Você está indo bem, com espaço para se sentir ainda melhor.";
      copy.textContent = "Suporte diário direcionado pode aliviar o inchaço e estabilizar sua energia nas primeiras semanas.";
    } else {
      title.textContent = "Você está em um bom lugar.";
      copy.textContent = "Suporte diário consistente mantém a leveza e a energia que você construiu.";
    }

    try {
      sessionStorage.setItem(
        "eon_quiz_answers",
        JSON.stringify({ answers, focus: lastFocus, scores: { overall, digestao, fibras, energia, foco } })
      );
    } catch (e) {}

    track("quiz_complete", {
      score: overall,
      badge: badgeFor(overall),
      focus: focusMap[weakest],
    });
  }

  // Projeção: ~1 semana ("menos inchaço, mais energia e foco, em menos de uma semana")
  function renderBridge(screen) {
    const el = screen.querySelector("[data-projection-date]");
    if (!el) return;
    const d = new Date();
    d.setDate(d.getDate() + 7);
    el.textContent = d.toLocaleDateString("pt-BR", { day: "numeric", month: "long" });
  }

  // Carousel
  function initCarousel(screen) {
    const car = screen.querySelector("[data-carousel]");
    if (!car || car.dataset.inited === "1") return;
    car.dataset.inited = "1";
    const track = car.querySelector("[data-track]");
    const slides = track.children;
    const dots = [...car.querySelectorAll("[data-dot]")];
    const prev = car.querySelector("[data-prev]");
    const next = car.querySelector("[data-next-slide]");
    const autoplayMs = parseInt(car.dataset.autoplay || "0", 10);
    let i = 0;
    let timer = null;

    const render = () => {
      track.style.transform = `translateX(-${i * 100}%)`;
      dots.forEach((d, idx) => d.classList.toggle("is-active", idx === i));
    };
    const go = (delta) => {
      i = (i + delta + slides.length) % slides.length;
      render();
      restart();
    };
    const restart = () => {
      if (!autoplayMs) return;
      clearInterval(timer);
      timer = setInterval(() => go(1), autoplayMs);
    };
    prev.addEventListener("click", (e) => { e.stopPropagation(); go(-1); });
    next.addEventListener("click", (e) => { e.stopPropagation(); go(1); });
    dots.forEach((d, idx) => d.addEventListener("click", (e) => { e.stopPropagation(); i = idx; render(); restart(); }));

    // touch swipe
    let startX = 0;
    track.addEventListener("touchstart", (e) => { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener("touchend", (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    });

    render();
    restart();
  }

  // wire up "next" buttons
  form.addEventListener("click", (e) => {
    const next = e.target.closest("[data-next]");
    if (!next) return;
    e.preventDefault();
    const screen = screens[index];
    if (!isAnswered(screen)) {
      next.animate(
        [
          { transform: "translateX(0)" },
          { transform: "translateX(-6px)" },
          { transform: "translateX(6px)" },
          { transform: "translateX(0)" },
        ],
        { duration: 240 }
      );
      return;
    }
    setStep(index + 1);
  });

  // auto-advance for radio (single-select), not checkbox
  form.addEventListener("change", (e) => {
    const screen = screens[index];
    if (e.target.type === "radio" || e.target.type === "checkbox") {
      track("quiz_answer", {
        question: e.target.name,
        value: e.target.value,
        checked: e.target.checked !== false,
      });
    }
    if (e.target.type !== "radio") return;
    if (screen.hasAttribute("data-multi")) return;
    setTimeout(() => setStep(index + 1), 220);
  });

  // back
  backBtn.addEventListener("click", () => {
    if (!history.length) return;
    const prev = history.pop();
    screens[index].classList.remove("is-active");
    index = prev;
    screens[index].classList.add("is-active");
    const pct = Math.round(((index + 1) / total) * 100);
    progressFill.style.width = pct + "%";
    stepCounter.textContent = `${index + 1} / ${total}`;
    backBtn.hidden = history.length === 0;
    applyChrome(screens[index].dataset.screen);
    window.scrollTo({ top: 0, behavior: "smooth" });
    location.hash = screens[index].dataset.screen;
  });

  // initial
  progressFill.style.width = `${Math.round((1 / total) * 100)}%`;
  stepCounter.textContent = `1 / ${total}`;
  track("quiz_view", { step: "age", index: 1, total: total });

  // The global Rebuy app embed auto-opens SmartCart on hydration. CSS hides its
  // flyout on the quiz; this also calls hide() so any scroll-lock is released.
  // Scoped: this file only runs on the quiz. Belt-and-suspenders, low cost.
  function closeRebuy() {
    try { if (window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.hide === "function") Rebuy.SmartCart.hide(); } catch (e) {}
  }
  document.addEventListener("rebuy.ready", closeRebuy);
  [800, 2000, 4000, 7000].forEach(function (t) { setTimeout(closeRebuy, t); });
})();
